<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left pr-0">
          <div class="title">
            {{ $t('sidebar.purchaseorder') }}
            <template v-if="ready">
              >
              {{ purchase.po_code }}
            </template>
          </div>
        </div>
        <template v-if="device.isMobile">
          <div class="col-7 right pl-0">
            <div
              v-if="ready"
              class="action">
              <div
                class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  class="btn no-bg dropdown-toggle text-secondary shake"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fas fa-cog"/>
                  <span class="name">{{ $t('button.options') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <a
                    v-if="hasRoleCreate"
                    class="dropdown-item"
                    @click="openCloneModal()">
                    <i class="fas fa-copy"/>
                    <span class="name">{{ $t('button.clone') }}</span>
                  </a>
                  <a
                    class="dropdown-item"
                    @click="openPrintModal()">
                    <i class="fas fa-print"/>
                    <span class="name">{{ $t('button.print') }}</span>
                  </a>
                  <a
                    class="dropdown-item"
                    @click="downloadPdf()">
                    <i class="fas fa-download"/>
                    <span class="text-secondary">
                      {{ $t('button.download') }} PDF
                    </span>
                  </a>
                  <a
                    v-if="hasRoleDelete"
                    class="dropdown-item"
                    @click="openConfirmdeleteModal()">
                    <i class="fas fa-trash text-danger"/>
                    <span class="text-danger">{{ $t('button.delete') }}</span>
                  </a>
                </div>
              </div>
              <!-- <div class="dropdown nodro item">
              <button class="btn no-bg text-secondary" type="button">
                <i class="fas fa-envelope"></i>
                <span class="name">{{ $t('button.sendemail') }}</span>
              </button>
            </div> -->
              <!-- <div class="dropdown nodro item">
              <button class="btn no-bg text-secondary" type="button" @click="openShareLinkModal()">
                <i class="fas fa-link"></i>
                <span class="name">{{ $t('button.sharelink') }}</span>
              </button>
            </div> -->
              <!-- status button -->
              <div
                v-if="purchase.status == 'padding' && hasRoleApprove"
                class="dropdown item">
                <template>
                  <button
                    v-if="purchase.status == 'padding'"
                    class="btn no-bg dropdown-toggle text-warning"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <i class="far fa-circle"/>
                    <span class="name">{{ $t('status.po.padding') }}</span>
                  </button>
                  <button
                    v-if="purchase.status == 'approved'"
                    class="btn no-bg dropdown-toggle text-info"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <i class="far fa-check-circle"/>
                    <span class="name">{{ $t('status.po.approved') }}</span>
                  </button>
                  <button
                    v-if="purchase.status == 'rejected'"
                    class="btn no-bg dropdown-toggle text-danger"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <i class="far fa-times-circle"/>
                    <span class="name">{{ $t('status.po.rejected') }}</span>
                  </button>
                </template>
                <div class="dropdown-menu dropdown-menu-right">
                  <a
                    v-if="purchase.status == 'padding'"
                    class="dropdown-item"
                    @click="updatePurchaseStatus({po_id: purchase.po_id, status: 'approved'})">
                    <i
                      class="far fa-check-circle text-info"
                      style="position: relative; left: -7px;"/>
                    <span class="text-info">{{ $t('status.po.approve') }}</span>
                  </a>
                  <a
                    v-if="purchase.status == 'padding'"
                    class="dropdown-item"
                    @click="updatePurchaseStatus({po_id: purchase.po_id, status: 'rejected'})">
                    <i
                      class="far fa-times-circle text-danger"
                      style="position: relative; left: -7px;"/>
                    <span class="text-danger">{{ $t('status.po.reject') }}</span>
                  </a>
                </div>
              </div>
              <!-- status message -->
              <div
                v-else
                class="dropdown nodro item">
                <template>
                  <span
                    v-if="getPurchaseStatus(purchase, $t, mixin).status == 'padding'"
                    class="text-warning">
                    {{ getPurchaseStatus(purchase, $t, mixin).message }}
                  </span>
                  <span
                    v-else-if="getPurchaseStatus(purchase, $t, mixin).status == 'completed'"
                    class="text-success">
                    {{ getPurchaseStatus(purchase, $t, mixin).message }}
                  </span>
                  <span
                    v-else-if="getPurchaseStatus(purchase, $t, mixin).status == 'uncompleted'"
                    class="text-info">
                    {{ getPurchaseStatus(purchase, $t, mixin).message }}
                  </span>
                  <span
                    v-else
                    class="text-danger">
                    {{ getPurchaseStatus(purchase, $t, mixin).message }}
                  </span>
                </template>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-8 right">
            <div
              v-if="ready"
              class="action">
              <div
                v-if="hasRoleDelete"
                class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  class="btn no-bg dropdown-toggle text-secondary shake"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fas fa-cog"/>
                  <span class="name">{{ $t('button.options') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <a
                    v-if="hasRoleDelete"
                    class="dropdown-item"
                    @click="openConfirmdeleteModal()">
                    <i class="fas fa-trash text-danger"/>
                    <span class="text-danger">{{ $t('button.delete') }}</span>
                  </a>
                </div>
              </div>
              <div
                class="dropdown nodro item">
                <button
                  class="btn no-bg text-secondary"
                  type="button"
                  @click="openCloneModal()">
                  <i class="fas fa-copy"/>
                  <span class="name">{{ $t('button.clone') }}</span>
                </button>
              </div>
              <div
                class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  class="btn no-bg dropdown-toggle text-secondary"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fas fa-download"/>
                  <span class="name">{{ $t('button.download') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <a
                    class="dropdown-item"
                    @click="downloadPdf()">
                    <span class="text-secondary">{{ $t('message.filename', {string: 'PDF'}) }}</span>
                  </a>
                </div>
              </div>
              <!-- <div class="dropdown nodro item">
              <button class="btn no-bg text-secondary" type="button">
                <i class="fas fa-envelope"></i>
                <span class="name">{{ $t('button.sendemail') }}</span>
              </button>
            </div> -->
              <!-- <div class="dropdown nodro item">
              <button class="btn no-bg text-secondary" type="button" @click="openShareLinkModal()">
                <i class="fas fa-link"></i>
                <span class="name">{{ $t('button.sharelink') }}</span>
              </button>
            </div> -->
              <div
                class="dropdown nodro item">
                <button
                  class="btn no-bg text-secondary"
                  type="button"
                  @click="openPrintModal()">
                  <i class="fas fa-print"/>
                  <span class="name">{{ $t('button.print') }}</span>
                </button>
              </div>
              <!-- status button -->
              <div
                v-if="purchase.status == 'padding' && hasRoleApprove"
                class="dropdown item">
                <template>
                  <button
                    v-if="purchase.status == 'padding'"
                    class="btn no-bg dropdown-toggle text-warning"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <i class="far fa-circle"/>
                    <span class="name">{{ $t('status.po.padding') }}</span>
                  </button>
                  <button
                    v-if="purchase.status == 'approved'"
                    class="btn no-bg dropdown-toggle text-info"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <i class="far fa-check-circle"/>
                    <span class="name">{{ $t('status.po.approved') }}</span>
                  </button>
                  <button
                    v-if="purchase.status == 'rejected'"
                    class="btn no-bg dropdown-toggle text-danger"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <i class="far fa-times-circle"/>
                    <span class="name">{{ $t('status.po.rejected') }}</span>
                  </button>
                </template>
                <div class="dropdown-menu dropdown-menu-right">
                  <a
                    v-if="purchase.status == 'padding'"
                    class="dropdown-item"
                    @click="updatePurchaseStatus({po_id: purchase.po_id, status: 'approved'})">
                    <i
                      class="far fa-check-circle text-info"
                      style="position: relative; left: -7px;"/>
                    <span class="text-info">{{ $t('status.po.approve') }}</span>
                  </a>
                  <a
                    v-if="purchase.status == 'padding'"
                    class="dropdown-item"
                    @click="updatePurchaseStatus({po_id: purchase.po_id, status: 'rejected'})">
                    <i
                      class="far fa-times-circle text-danger"
                      style="position: relative; left: -7px;"/>
                    <span class="text-danger">{{ $t('status.po.reject') }}</span>
                  </a>
                </div>
              </div>
              <!-- status message -->
              <div
                v-else
                class="dropdown nodro item">
                <template>
                  <span
                    v-if="getPurchaseStatus(purchase, $t, mixin).status == 'padding'"
                    class="text-warning">
                    {{ getPurchaseStatus(purchase, $t, mixin).message }}
                  </span>
                  <span
                    v-else-if="getPurchaseStatus(purchase, $t, mixin).status == 'completed'"
                    class="text-success">
                    {{ getPurchaseStatus(purchase, $t, mixin).message }}
                  </span>
                  <span
                    v-else-if="getPurchaseStatus(purchase, $t, mixin).status == 'uncompleted'"
                    class="text-info">
                    {{ getPurchaseStatus(purchase, $t, mixin).message }}
                  </span>
                  <span
                    v-else
                    class="text-danger">
                    {{ getPurchaseStatus(purchase, $t, mixin).message }}
                  </span>
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <WrapperDoc>
          <template #form>
            <section>
              <div class="col-md-12 no-padding">
                <section-header
                  :title="$t('message.vendor')"
                  :subtitle="$t('series.po') + ' ' + purchase.po_code"/>
                <div class="form-row">
                  <div class="col-md-12">
                    <div class="form-group row">
                      <div class="col">
                        <label>{{ $t('message.storecompanyperson') }}</label>
                        <selectize
                          v-model="form.pickedVendorId"
                          :default="form.defaultVendorId"
                          :updateoption="form.updateOptionVendor"
                          :options="form.optionVendors"
                          :multiple="false"
                          :create="true"
                          :loading="form.loadingVendor"
                          :validation="form.trickValidationVendor"
                          :placeholder="$t('placeholder.selectorcreate')"
                          :disabled="disabledForm"
                          @add="onAddedVendor" />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="form.pickedVendorId"
                  class="form-row">
                  <div class="col-md-6">
                    <div
                      class="form-group row"
                      style="height: 100%;">
                      <div class="col-md-12">
                        <label>{{ $t('message.address') }}</label>
                        <textarea
                          v-model="form.vendor.address"
                          :disabled="disabledForm"
                          class="form-control"
                          style="height: calc(100% - 37px);"/>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.tel') }}</label>
                        <input
                          v-model="form.vendor.tel"
                          :disabled="disabledForm"
                          type="text"
                          class="form-control">
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.email') }}</label>
                        <input
                          v-model="form.vendor.email"
                          :disabled="disabledForm"
                          type="text"
                          class="form-control">
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.taxpayerno') }}</label>
                        <input
                          v-model="form.vendor.tax_id"
                          :disabled="disabledForm"
                          type="text"
                          class="form-control">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section>
              <div class="col-md-12 no-padding">
                <section-header :title="$t('message.date')"/>
                <div class="form-row">
                  <div class="col">
                    <div class="form-group row">
                      <div class="col">
                        <label>{{ $t('message.date') }}</label>
                        <BaseInputDatePicker
                          v-model="form.created_at"
                          :disabled="disabledForm"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group row">
                      <div class="col">
                        <label>{{ $t('apps.purchases.message.purchasetype') }}</label>
                        <BaseDropdown
                          v-model="form.purchase_type"
                          :options="purchaseOptions"
                          :disabled="disabledForm"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="col"
                    @click="isFocusOnInputScheduled = false">
                    <div class="form-group row">
                      <div class="col">
                        <label>{{ $t('message.credittype') }}</label>
                        <select
                          v-if="form.selectedCredit !== 'custom'"
                          v-model="form.selectedCredit"
                          :disabled="disabledForm"
                          class="form-control custom-select"
                        >
                          <option value="cash">{{ $t('message.cash') }}</option>
                          <option value="days.15">{{ $t('message.creditdasys', {number: 15}) }}</option>
                          <option value="days.30">{{ $t('message.creditdasys', {number: 30}) }}</option>
                          <option value="days.60">{{ $t('message.creditdasys', {number: 60}) }}</option>
                          <option value="days.90">{{ $t('message.creditdasys', {number: 90}) }}</option>
                          <option value="custom">{{ $t('message.customcreditdays') }}</option>
                        </select>
                        <div
                          v-else
                          class="input-group">
                          <input
                            ref="custom_credit_days"
                            v-model="form.inputCustomCreditDay"
                            :disabled="disabledForm"
                            type="text"
                            class="form-control text-right number-only text-select-all"
                            style="border-right: none;"
                            @keyup="keyupInputCustomCreditDay">
                          <div class="input-group-prepend">
                            <button
                              :disabled="disabledForm"
                              :class="[
                                disabledForm ? 'btn-light' : 'btn-web'
                              ]"
                              class="btn"
                              type="button"
                              style="border: 1px solid #ced4da;"
                              @click="form.selectedCredit = 'cash'">
                              {{ $t('message.creditdasysbutton') }} <i
                                v-if="!disabledForm"
                                class="far fa-times-circle"/>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="form.selectedCredit !== 'cash'"
                    :class="{'disabled': false}"
                    class="col scheduled">
                    <div class="form-group row">
                      <div
                        class="col-md-12"
                        style="position: relative;">
                        <div class="overlay"/>
                        <label>{{ $t('message.scheduled_at') }}</label>
                        <BaseInputDatePicker
                          v-model="form.scheduled_at"
                          :availableDates="{ start: form.created_at, end: null }"
                          :disabled="disabledForm"
                          @dayclick="isFocusOnInputScheduled = true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section>
              <div class="col-md-12 no-padding">
                <section-header :title="$t('message.orderlist')"/>
                <order
                  :validation="form.trickValidation"
                  :data="form.orders"
                  :createAble="true"
                  :showProductImage="true"
                  :disabled="disabledForm"
                  :showTooltipTaxHint="showTooltipTaxHint"
                  type="po"
                  @submit="onSubmitOrder"
                />
              </div>
            </section>
            <section class="no-margin">
              <div class="col-md-12 no-padding">
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <b-form-textarea
                          :placeholder="$t('placeholder.note')"
                          v-model="form.note"
                          :disabled="disabledForm"
                          style="min-height: 126px;" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 pl-2">
                    <div class="col-md-12 row no-padding no-margin">
                      <div class="col-12 row no-margin no-padding">
                        <div class="col-6 no-padding mb-2">
                          {{ $t('message.total') }}
                        </div>
                        <div class="col-6 no-padding mb-2 text-right">
                          {{ getNumber(total.sub) }}
                        </div>
                      </div>
                      <div
                        v-if="total.discount > 0"
                        class="col-12 row no-margin no-padding">
                        <div class="col-6 no-padding mb-2">
                          {{ $t('message.discount') }}
                        </div>
                        <div class="col-6 no-padding mb-2 text-right">
                          {{ getNumber(total.discount) }}
                        </div>
                      </div>
                      <div
                        v-if="total.discount > 0"
                        class="col-12 row no-margin no-padding">
                        <div class="col-6 no-padding mb-2">
                          {{ $t('message.discounted_total') }}
                        </div>
                        <div class="col-6 no-padding mb-2 text-right">
                          {{ getNumber(total.sub - total.discount) }}
                        </div>
                      </div>
                      <div
                        v-if="total.taxes.vat.inclusive > 0"
                        class="col-12 row no-margin no-padding">
                        <div class="col-6 no-padding mb-2">
                          {{ $t('message.totalexcludingvat') }}
                        </div>
                        <div class="col-6 no-padding mb-2 text-right">
                          {{ getNumber(total.untaxed) }}
                        </div>
                      </div>
                      <div
                        v-for="(tax, index) in taxResults"
                        :key="index"
                        class="col-12 row no-margin no-padding"
                      >
                        <div class="col-6 no-padding mb-2">
                          {{ tax.displayText }}
                        </div>
                        <div class="col-6 no-padding mb-2 text-right">
                          {{ getNumber(tax.total) }}
                        </div>
                      </div>
                      <div class="col-12 row no-margin no-padding">
                        <div class="col-6 no-padding">
                          {{ $t('message.grandtotal') }}
                        </div>
                        <div class="col-6 no-padding text-right">
                          <span :class="[{'text-underline-border': !form.switchWithHoldingTax}]">
                            {{ getNumber(total.grand) }}
                          </span>
                        </div>
                      </div>
                      <div
                        v-if="showLegacyWht()"
                        class="col-12 row no-margin no-padding">
                        <div class="col-12 no-padding"><hr style="border-top: solid 1px #D8E2E7;"></div>
                      </div>
                    </div>
                    <template v-if="showLegacyWht()">
                      <div
                        class="form-group row mb-0"
                        style="height: 35px;">
                        <div
                          class="col-8"
                          style="position: relative; top: 3px;opacity: 0.3;"
                          @click="showTooltipTaxHint = true"
                        >
                          <vs-switch
                            v-model="form.switchWithHoldingTax"
                            :disabled="true"
                            style="float: left;margin: 0 10px 0 0"
                            color="#A3CA76"
                          />
                          {{ $t('message.wht') }}
                        </div>
                        <div class="col-4">
                          <select
                            v-if="form.switchWithHoldingTax"
                            v-model="form.inputWithHoldingTax"
                            :disabled="disabledForm"
                            class="custom-select form-control">
                            <option value="0">0%</option>
                            <option value="-1">{{ $t('message.wht1') }}</option>
                            <option value="-2">{{ $t('message.wht2') }}</option>
                            <option value="-3">{{ $t('message.wht3') }}</option>
                            <option value="-5">{{ $t('message.wht5') }}</option>
                          </select>
                        </div>
                      </div>
                      <div
                        v-if="form.switchWithHoldingTax"
                        class="col-md-12 row no-padding mt-2 ml-0 mr-0">
                        <div class="col-12 row no-margin no-padding">
                          <div class="col-6 no-padding mb-2">
                            {{ $t('message.wht') }}
                          </div>
                          <div class="col-6 no-padding mb-2 text-right">
                            {{ getNumber(total.taxes.wht.toString().replace("-", "")) }}
                          </div>
                        </div>
                        <div class="col-12 row no-margin no-padding">
                          <div class="col-6 no-padding">
                            {{ $t('message.paymentamount') }}
                          </div>
                          <div class="col-6 no-padding text-right">
                            <span class="text-underline-border">{{ getNumber(total.payment) }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </section>
            <section
              v-if="!disabledForm"
              class="action-bar"
            >
              <template>
                <div
                  v-if="!$store.state.app.loading"
                  class="col-md-12 text-right">
                  <button
                    class="btn btn-web"
                    @click="form.trickValidation++;">{{ $t('button.save') }}</button>
                </div>
                <div
                  v-else
                  class="col-md-12 text-right">
                  <!-- <button class="btn btn-light btn-block-mobile-only" disabled>{{ $t('button.cancel') }}</button> -->
                  <button
                    class="btn btn-web btn-block-mobile-only"
                    disabled><i class="fas fa-spinner spin"/></button>
                </div>
              </template>
            </section>
          </template>
          <template #ref>
            <DocRef
              :refDoc="`po`"
              :refId="purchase.po_id"
              :refCode="purchase.po_code"
              :showLog="getPurchaseSetting.log_topic.is_active"
              :showAttachFile="getPurchaseSetting.attach_file.is_active"
              :logTopics="getPurchaseSetting.log_topic.options"
              :isSubmitted="isSubmitted"
            >
              <RefPO
                :purchase="purchase"
                :disabled="!hasRoleCreate"
              />
            </DocRef>
          </template>
        </WrapperDoc>
      </template>
    </div>

    <div
      id="confirmdeleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog"
        role="document">
        <div
          v-if="ready"
          class="modal-content">
          <div
            :class="[{'no-border-bottom': purchase.reference.payments.length == 0 && purchase.reference.goodsreceipts.length == 0}]"
            class="modal-header">
            <h5 class="modal-title">
              {{ $t('message.areyousuretodeletethis') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeConfirmdeleteModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="purchase.reference.payments.length > 0 || purchase.reference.goodsreceipts.length > 0"
            class="modal-body">
            <p class="text-danger">
              <strong>{{ $t('message.refdocswillbedeleted') }}</strong>
            </p>
            <div v-if="purchase.reference.payments.length > 0">
              <p class="m-0">
                <strong>{{ $t('documents.pe') }} ({{ purchase.reference.payments.length }})</strong>
              </p>
              <ul>
                <li
                  v-for="(payment, index) in purchase.reference.payments"
                  :key="index">
                  <router-link-custom
                    :to="{name: 'AccountsPaymentEntryEdit', query: {
                      pe_id: payment.pe_id,
                      pe_code: payment.pe_code
                    }}"
                    :text="payment.pe_code"
                    :status="{
                      text: getPaymentStatus(payment, $t).message,
                      color: getColorFormStatus(getPaymentStatus(payment, $t).status),
                      type: 'icon'
                    }"
                    :to_appid="12"
                    :current_appid="4"/>
                </li>
              </ul>
            </div>
            <div v-if="purchase.reference.goodsreceipts.length > 0">
              <p class="m-0">
                <strong>{{ $t('documents.gr') }} ({{ purchase.reference.goodsreceipts.length }})</strong>
              </p>
              <ul>
                <li
                  v-for="(goodsreceipt, index) in purchase.reference.goodsreceipts"
                  :key="index">
                  <router-link-custom
                    :to="{name: 'GoodsReceiptEdit', query: {
                      gr_id: goodsreceipt.gr_id,
                      gr_code: goodsreceipt.gr_code
                    }}"
                    :text="goodsreceipt.gr_code"
                    :status="{
                      text: getGoodsReceiptStatus(goodsreceipt, $t).message,
                      color: getColorFormStatus(getGoodsReceiptStatus(goodsreceipt, $t).status),
                      type: 'icon'
                    }"
                    :to_appid="3"
                    :current_appid="4"/>
                </li>
              </ul>
            </div>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeConfirmdeleteModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="del()">{{ $t('button.delete') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="printModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-print-a4"
        role="document">
        <div class="modal-content">
          <div
            class="modal-body p-0"
            style="background: #C9CCCE;height: 660px;overflow: auto;">
            <printpurchase-view
              v-if="ready"
              :purchase="purchase"
              :fontSize="getPurchaseSetting.doc_template.font_size"
              :isFixedSignatureBottom="getPurchaseSetting.doc_template.is_fixed_signature_bottom"
              class="print-template"/>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-web"
              @click="onclickPrint()">{{ $t('button.print') }}</button>
            <button
              type="button"
              class="btn btn-light"
              @click="closePrintModal()">{{ $t('button.close') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="sharelinkModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $t('button.sharelink') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeShareLinkModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section class="link">
              <section-title :title="$t('message.link')"/>
              <div class="col-md-12 p-0 wrapper-link">
                <input
                  id="sharelink"
                  type="text"
                  class="form-control text-clipboard"
                  readonly="readonly"
                  value="https://doc.treesoft.io/th/eWRhpRV">
                <a
                  href="https://doc.treesoft.io/th/eWRhpRV"
                  target="_blank"
                  class="btn btn-sm btn-secondary"
                  style="right: 59px;">ไปยัง</a>
                <button
                  class="btn btn-sm btn-secondary btn-copy"
                  data-ref="sharelink"
                  style="right: 7px;">คัดลอก</button>
              </div>
            </section>
            <section class="mb-0">
              <section-title :title="$t('message.permissions')"/>
              <div class="col-md-12 p-0">
                <div class="form-row">
                  <div class="col-6">
                    <div class="form-group row mb-2">
                      <div class="col-12">
                        <vs-checkbox
                          color="#A3CA76"
                          style="float: left;margin: 0;"
                        >{{ $t('button.download') }}</vs-checkbox>
                      </div>
                    </div>
                    <div class="form-group row mb-0">
                      <div class="col-12">
                        <vs-checkbox
                          color="#A3CA76"
                          style="float: left;margin: 0;"
                        >{{ $t('message.approve') }}</vs-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group row mb-2">
                      <div class="col-12">
                        <vs-checkbox
                          color="#A3CA76"
                          style="float: left;margin: 0;"
                        >{{ $t('button.print') }}</vs-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeShareLinkModal()">{{ $t('button.close') }}</button>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

    <BaseConfirmCloneModal
      :show="modalConfirmClone.show"
      :loading="modalConfirmClone.loading"
      @onClose="handleCloseCloneModal"
      @onCancel="handleCancleCloneModal"
      @onConfirm="handleConfirmCloneModal({
        payload: payloadClone,
        createApiFn: insertPurchase,
        redirectTo: 'PurchaseOrderAll',
        refCode: 'purchase.po_code',
      })"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import printpurchaseView from '@/components/apps/purchases/po/include/PrintPurchase.vue'
import WrapperDoc from '@/components/combine/WrapperDoc.vue'
import DocRef from '@/components/combine/DocRef.vue'
import RefPO from '@/components/apps/purchases/po/include/RefPO.vue'
import BaseConfirmCloneModal from '@/components/base/BaseConfirmCloneModal'
import _ from 'lodash'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'
import confirmCloneMixin from '@/mixins/confirmClone'
import { getMasterDataText } from '../../../../helpers'
const jwt = require('jsonwebtoken')

export default {
  components: {
    printpurchaseView,
    WrapperDoc,
    DocRef,
    RefPO,
    BaseConfirmCloneModal,
  },
  mixins: [discardFormMixin, userPermissionMixin, confirmCloneMixin],
  data () {
    return {
      ready: false,

      form: {
        pickedVendorId: null,
        defaultVendorId: null,
        optionVendors: [],
        updateOptionVendor: null,
        loadingVendor: false,
        trickValidationVendor: 0,
        vendor: {
          address: null,
          tax_id: null,
          email: null,
          tel: null,
        },

        created_at: new Date(),

        purchase_type: null,

        scheduled_at: new Date(),
        selectedCredit: '',

        inputCustomCreditDay: 0,
        inputWithHoldingTax: 0,

        switchWithHoldingTax: false,

        note: '',
        trickValidation: 0,
        orders: [],
      },

      originalForm: null,

      isFocusOnInputScheduled: false,

      isCreateAnother: false,

      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null,
        dayPopover: null,
      },

      isSubmitted: false,

      showTooltipTaxHint: false,
    }
  },
  computed: {
    ...mapGetters({
      sidebar: 'getSidebar',
      products: 'getProducts',
      vendors: 'getVendors',
      currency: 'getCurrency',
      purchase: 'getPurchase',
      dateformat: 'getDateFormat',
      getPurchaseStatus: 'getPurchaseStatus',
      vat: 'getVat',
      getVendorById: 'getVendorById',
      getPartnerContact: 'getPartnerContact',
      getDataSetPartnerUpdate: 'getDataSetPartnerUpdate',
      getShopInfo: 'getShopInfo',
      getLang: 'getLang',
      getPaymentStatus: 'getPaymentStatus',
      getGoodsReceiptStatus: 'getGoodsReceiptStatus',
      getPurchaseSetting: 'getPurchaseSetting',
      purchaseSetting: 'getPurchaseSetting',
    }),
    purchaseTypes() {
      if (this.purchaseSetting && this.purchaseSetting.types) {
        return this.purchaseSetting.types
      }
      return []
    },
    purchaseOptions() {
      return this.purchaseTypes
        .filter((type) => type.is_active)
        .map((type) => {
          return {
            text: getMasterDataText(type.name, this.$t),
            value: type.name,
          }
        })
    },
    defaultPurchaseType() {
      return this.purchaseTypes.find((type) => type.is_default).name
    },
    total () {
      let orders = this.getDataSetOrders(this.form.orders)
      return this.getTotal(orders)
    },
    taxResults () {
      const isGroupTaxName = false
      const oders = this.getDataSetOrders(this.form.orders)
      return this.getTaxesByOrders(oders, isGroupTaxName).map((tax) => {
        return {
          form_type: tax.form_type,
          taxRate: tax.amount,
          total: (() => {
            if (tax.amount <= -1) {
              return Math.abs(tax.total)
            }
            return tax.total
          })(),
          displayText: tax.displayText,
        }
      })
    },
    whtRate () {
      var whtPercent = undefined
      for (let i in this.purchase.orders) {
        let order = this.purchase.orders[i]
        for (let j in order.taxes) {
          let tax = order.taxes[j]
          if (tax.name == '{wht}') {
            whtPercent = tax.amount
          }
        }
      }
      return whtPercent
    },
    disabledForm () {
      return [
        'approved',
        'rejected',
      ].includes(this.purchase.status) || !this.hasRoleEdit
    },
    payloadClone() {
      const dataSet = {
        'doc_type': 'po',
        'status': 'padding',
        'note': this.purchase.note,
        'created_at': this.purchase.created_at,
        'scheduled_at': this.purchase.scheduled_at,
        'vendor_id': this.purchase.vendor.vendor_id,
        'purchase_type': this.purchase.purchase_type,
        'credit': {
        	'type': this.purchase.credit.type,
        	'days': this.purchase.credit.days,
        },
        'orders': this.purchase.orders.map((order) => ({
          'item': order.item,
        	'description': order.description,
        	'price': order.price,
        	'quantity': order.quantity,
        	'sku_id': order.sku_id,
          'discounts': order.discounts,
          'taxes': order.taxes,
        })),
      }
      return dataSet
    },
  },
  methods: {
    ...mapActions([
      'insertPurchase',
    ]),
    async onAddedVendor (value) {
      // show loading selectize
      this.form.loadingVendor = true

      // insert new vendor
      let res = await this.$store.dispatch('insertVendor', { name: value })

      if (res.success) {
        let vendor = res.data
        // update option value
        this.form.updateOptionVendor = {
          text: value,
          value: vendor.vendor_id,
          picked: true,
        }
        this.form.optionVendors.push({
          text: value,
          value: vendor.vendor_id,
        })
        // finish loading
        this.showFinish(this.$Progress)
        // hide loading selectize
        this.form.loadingVendor = false
      }
    },
    onSubmitOrder (isValid, orders) {
      this.isSubmitted = true
      this.form.trickValidationVendor++

      let isInValid = !isValid || (this.form.pickedVendorId == null || this.form.pickedVendorId == '')

      if (isInValid) {
        return $('html, body').animate({ scrollTop: 0 }, 'slow')
      }

      this.save(this.getDataSetOrders(orders))
    },
    async save (orders) {
      let creditType = 'cash'
      let creditDays = 0

      if (this.form.selectedCredit == 'custom') {
        creditType = 'days'
        creditDays = this.form.inputCustomCreditDay
      } else if (this.form.selectedCredit.search('days.') >= 0) {
        let arr = this.form.selectedCredit.split('.')
        let days = arr[1]
        creditType = 'days'
        creditDays = days
      }

      let dataSet = {
        'po_id': this.purchase.po_id,
        'status': this.purchase.status,
        'note': this.form.note ? this.form.note : null,
        'created_at': this.form.created_at.toISOString(),
        'scheduled_at': this.form.scheduled_at.toISOString(),
        'vendor_id': this.form.pickedVendorId,
        'purchase_type': this.form.purchase_type,
        'credit': {
        	'type': creditType,
        	'days': parseInt(creditDays),
        },
        'orders': [],
      }

      for (let i in orders) {
        let order = orders[i]
        dataSet['orders'].push({
          'item': order.item,
        	'description': order.description,
        	'price': order.price,
        	'quantity': order.quantity,
        	'sku_id': order.sku_id,
          'discounts': order.discounts,
          'taxes': order.taxes,
        })
      }

      // update vendor
      let dataSetVendorUpdate = this.getDataSetPartnerUpdate('vendor', this.form.pickedVendorId, this.form.vendor, this.vendors)
      if (dataSetVendorUpdate !== null) {
        await this.$store.dispatch('updateVendor', dataSetVendorUpdate)
        await this.$store.dispatch('getVendors')
      }

      let res = await this.$store.dispatch('updatePurchase', dataSet)

      if (res.success) {
        let po_code = res.data.purchase.po_code
        // get
        await this.$store.dispatch('getPurchase', {
          po_id: this.purchase.po_id,
          doc_type: 'po',
        })
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.purchase.po_code }),
          color: 'success',
          icon: 'cloud',
        })
        // set data
        this.setData()
        this.isSubmitted = false
        // loading finish
        this.showFinish(this.$Progress)
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }
    },
    getDataSetOrders (orders) {
      const data = _.cloneDeep(orders)
      const newData = []
      // remove key, data we don't need
      for (const i in data) {
        const item = data[i]
        if (item.sku_id) {
          newData.push({
            item: item.item,
            description: item.description,
            sku_id: item.sku_id,
            quantity: parseFloat(item.quantity) || 0,
            price: parseFloat(item.price) || 0,
            discounts: item.discounts.map((discount) => ({
              ...discount,
              type: 'general',
              value_amount: parseFloat(discount.value_amount),
            })),
            taxes: item.taxes.map((tax) => ({
              name: tax.tax_name,
              type: tax.type,
              amount: tax.amount,
              form_type: tax.form_type,
              group_name: tax.group_name,
              is_display_fee_result: tax.is_display_fee_result,
              is_for_sale: tax.is_for_sale,
              is_for_purchase: tax.is_for_purchase,
              fee: tax.fee ? tax.fee : null,
              tax_id: tax.tax_id,
            })),
          })
        }
      }
      return newData
    },
    async clearForm () {
      let that = this

      this.ready = false

      this.form = _.cloneDeep(this.originalForm)

      setTimeout(() => {
        that.ready = true
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }, 100)
    },
    keyupInputCustomCreditDay (e) {
      var value = this.form.inputCustomCreditDay.toString()
      if (value) {
        if (value.search('0') == 0) {
          value = value.substring(1, value.length)
          this.form.inputCustomCreditDay = value
        }
      }
    },
    openConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('show')
    },
    closeConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('hide')
    },
    async del () {
      let data = {
        po_id: this.purchase.po_id,
      }

      // delete reference payments
      this.purchase.reference.payments.map(async (payment) => {
        let data = {
          'pe_id': payment.pe_id,
          'reference': {
            'po_id': this.purchase.po_id,
          },
        }
        let res = await this.$store.dispatch('deletePayment', data)
      })

      // delete reference payments
      this.purchase.reference.goodsreceipts.map(async (goodsreceipt) => {
        let data = {
          gr_id: goodsreceipt.gr_id,
        }
        let res = await this.$store.dispatch('deleteGoodsreceipt', data)
      })

      // delete purchase
      let res = await this.$store.dispatch('deletePurchase', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.purchase.po_code }),
          color: 'danger',
          icon: 'delete',
        })
        // finish loading
        this.showFinish(this.$Progress)
        // close modal
        this.closeConfirmdeleteModal()
        // go to
        return this.$router.push({ name: 'PurchaseOrderAll' })
      }
    },
    async updatePurchaseStatus (data) {
      this.isSubmitted = true
      let res = await this.$store.dispatch('updatePurchaseStatus', {
        po_id: data.po_id,
        status: data.status,
        doc_type: 'po',
      })
      this.showFinish(this.$Progress)
      this.isSubmitted = false
    },
    setData () {
      let purchase = this.purchase
      let form = this.form

      this.form.purchase_type = purchase.purchase_type

      if (purchase.credit.type == 'days') {
        var arr = [15, 30, 60, 90]
        if (arr.indexOf(purchase.credit.days) >= 0) {
          form.selectedCredit = 'days.' + purchase.credit.days.toString()
        } else {
          form.selectedCredit = 'custom'
          form.inputCustomCreditDay = purchase.credit.days.toString()
        }
      } else {
        form.selectedCredit = purchase.credit.type
      }

      form.switchWithHoldingTax = !!this.whtRate
      form.inputWithHoldingTax = this.whtRate || 0

      form.note = purchase.note

      // set vendor
      this.form.vendor.address = purchase.vendor.address
      this.form.vendor.tax_id = purchase.vendor.tax_id
      this.form.vendor.email = this.getPartnerContact(purchase.vendor.contacts).email
      this.form.vendor.tel = this.getPartnerContact(purchase.vendor.contacts).tel

      // set defaultVendorId
      if (this.purchase.vendor) {
        this.form.defaultVendorId = this.purchase.vendor.vendor_id
      } else {
        this.form.defaultVendorId = null
      }

      this.form.created_at = new Date(purchase.created_at)
      if (this.form.scheduled_at) {
        this.form.scheduled_at = new Date(purchase.scheduled_at)
      }

      // set default data for Order.vue
      this.form.orders = this.getDefaultDataForOrderVue(this.purchase.orders)

      // set originalForm
      this.originalForm = _.cloneDeep(form)
    },
    onclickPrint () {
      $('.print-template').printThis({
        importStyle: true, // import style tag
      })
    },
    openPrintModal () {
      $('#printModal').modal('show')

      // set modal height
      $('#printModal .modal-body').css({
        height: window.innerHeight - 125 + 'px',
      })

      $('#printModal .modal-body').animate({ scrollTop: 0 }, 0)
    },
    closePrintModal () {
      $('#printModal').modal('hide')
    },
    openShareLinkModal () {
      $('#sharelinkModal').modal('show')
      $('input#sharelink').select()
    },
    closeShareLinkModal () {
      $('#sharelinkModal').modal('hide')
    },
    async downloadPdf () {
      let data = {
        'type': 'po',
        'lang': this.getLang,
        'id': this.purchase.po_id,
        'shop_id': this.getShopInfo.shop_id,
      }

      let token = jwt.sign(data, this.project.config.token.secret, { expiresIn: this.project.config.token.download_pdf_expiresin })

      var link = document.createElement('a')
      // link.href = this.project.config.web.api_doc_gen_01 + 'file/pdf/' + token + '/' + this.purchase.po_code
      // link.href = this.project.config.web.doc + 'pdf/' + token + '/' + this.purchase.po_code
      link.href = this.project.config.web.api + 'file/pdf/' + token + '/' + this.purchase.po_code
      link.target = '_blank'
      link.dispatchEvent(new MouseEvent('click'))
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    vendors: function (after, before) {
      this.form.optionVendors = []
      for (let i in after) {
        let vendor = after[i]
        this.form.optionVendors.push({
          text: vendor.vendor_name,
          value: vendor.vendor_id,
        })
      }
    },
    'form.switchWithHoldingTax': {
      handler: function (after) {
        let bool = after
        if (bool == false) {
          this.form.inputWithHoldingTax = '0'
        }
      },
      deep: true,
    },
    'form.selectedCredit': {
      handler: function (after, before) {
        if (!before) {
          return
        }
        let value = after
        if (value.search('days.') >= 0) {
          let arr = value.split('.')
          let days = parseInt(arr[1])
          this.form.scheduled_at = this.moment(this.form.created_at).add(days, 'day').toDate()
        } else if (value == 'custom') {
          let that = this
          if (!this.isFocusOnInputScheduled) {
            if (before.search('days.') >= 0) {
              let arr = before.split('.')
              let days = parseInt(arr[1])
              this.form.inputCustomCreditDay = days
            } else {
              this.form.scheduled_at = this.moment(this.form.created_at).toDate()
              this.form.inputCustomCreditDay = 0
            }
          }
          setTimeout(() => {
            that.$refs.custom_credit_days.focus()
          }, 100)
        } else if (value == 'cash') {
          this.form.scheduled_at = this.moment(this.form.created_at).toDate()
        }
      },
      deep: true,
    },
    'form.created_at': {
      handler: function (after) {
        var days = null

        if (this.form.selectedCredit == 'custom') {
          days = parseInt(this.form.inputCustomCreditDay)
        } else if (this.form.selectedCredit.search('days.') >= 0) {
          let arr = this.form.selectedCredit.split('.')
          days = parseInt(arr[1])
        }

        if (days !== null) {
          this.form.scheduled_at = this.moment(this.form.created_at).add(days, 'day').toDate()
        }
      },
      deep: true,
    },
    'form.scheduled_at': {
      handler: function (after, before) {
        if (this.isFocusOnInputScheduled) {
          if (this.form.selectedCredit.search('days.') >= 0 || this.form.selectedCredit == 'custom') {
            var a = this.moment(this.form.scheduled_at)
            var b = this.moment(this.form.created_at)
            var diff = Math.round(a.diff(b, 'days', true)) // diff days
            this.form.inputCustomCreditDay = diff
            this.form.selectedCredit = 'custom'
          }
        }
      },
      deep: true,
    },
    'form.inputCustomCreditDay': {
      handler: function (after) {
        var value = after.toString()
        let days = parseInt(value)
        if (days >= 0) {
          this.form.scheduled_at = this.moment(this.form.created_at).add(days, 'day').toDate()
        } else {
          this.form.inputCustomCreditDay = 0
        }
      },
      deep: true,
    },
    'form.pickedVendorId': {
      handler: function (after) {
        let vendor_id = after
        let vendorInfo = this.getVendorById(vendor_id)

        this.form.vendor.address = null
        this.form.vendor.tax_id = null
        this.form.vendor.email = null
        this.form.vendor.tel = null

        if (vendorInfo) {
          this.form.vendor.address = vendorInfo.address
          this.form.vendor.tax_id = vendorInfo.tax_id
          this.form.vendor.email = this.getPartnerContact(vendorInfo.contacts).email
          this.form.vendor.tel = this.getPartnerContact(vendorInfo.contacts).tel
        }
      },
      deep: true,
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    /**
     *  validation
     */
    if (!this.$route.query.id) {
      return this.$router.push({ name: 'PurchaseOrderAll' })
    }
    // get category
    let res = await this.$store.dispatch('getPurchase', {
      po_id: this.$route.query.id,
      doc_type: 'po',
    })
    if (!res.success) {
      return this.$router.push({ name: 'PurchaseOrderAll' })
    }
    if (res.data.length == 0) {
      return this.$router.push({ name: 'PurchaseOrderAll' })
    }
    /**
     *  validation success
     */
    // set date format
    this.formats.input = [this.dateformat]
    this.formats.dayPopover = this.dateformat
    // get vendors
    await this.$store.dispatch('getVendors')
    // get taxes
    await this.$store.dispatch('getTaxes')

    for (let i = 0; i < this.purchase.orders.length; i++) {
      const order = this.purchase.orders[i]
      await this.$store.dispatch('getProductWithMerge', {
        sku_id: order.sku_id,
      })
    }

    // set data
    this.setData()
    // set ready
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.purchases.title'),
      current: {
        app_name: 'purchases',
        app_id: 4,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, [{
      'name': this.$route.query.code,
      'router': {
        'name': 'PurchaseOrderEdit',
        'query': {
          id: this.$route.query.id,
          code: this.$route.query.code,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 1,
      submenuAtIdx: 2,
    })
  },
  mounted: function () {
    // set popup modal
    this.setModal('#confirmdeleteModal')
    this.setModal('#printModal')
    this.setModal('#sharelinkModal')
  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearProducts', 'clearVendors', 'clearPurchase'])
  },
}
</script>

<style scoped>
  .scheduled {
    position: relative;
  }
  .scheduled .overlay {
    display: none;
  }
  .scheduled.disabled .overlay {
    position: absolute;
    width: -webkit-calc(100% - 30px);
  	width:    -moz-calc(100% - 30px);
  	width:         calc(100% - 30px);
    height: 38px;
    top: 32px;
    left: 15px;
    z-index: 1;
    display: block;
  }
</style>

<style>
.scheduled.disabled .popover-container input {
  background: #e9ecef !important;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/purchases/po/Edit.vue